import Vue from 'vue'
import Vuex from 'vuex'
import modules from './loadModules'

Vue.use(Vuex)

export function createStore () {
  return new Vuex.Store({
    modules
  })
}



// WEBPACK FOOTER //
// ./src/store/index.js